import classNames from 'classnames';
import React from 'react';

const WhatHappensNext = props => {
  const steps = [
    {
      id: 1,
      title: 'Form Submission',
      content: 'Once you submit your details, we receive your inquiry immediately',
      active: true,
    },
    { id: 2, title: 'Initial Review', content: 'Our team reviews your information to understand your needs and goals.', active: false },
    {
      id: 3,
      title: 'Contact',
      content: 'Within 24 hours, one of our account managers will reach out to you via email or phone to discuss further details.',
      active: false,
    },
    {
      id: 4,
      title: 'Proposal',
      content: "After our discussion, we'll craft a customized SEO proposal tailored to your goals and budget.",
      active: false,
    },
    {
      id: 5,
      title: 'Agreement',
      content: 'If you decide to proceed, we’ll finalize the terms and kick off your SEO project.',
      active: false,
    },
  ];

  return (
    <ul>
      {steps.map(({ id, active, title, content }, index) => {
        return (
          <li key={index} className="mb-4">
            <h2 className={classNames(active && 'text-[#F7931A]', 'flex items-center gap-[20px] text-[18px] font-[600] leading-[21px]')}>
              <span className="min-w-[15px]">{id}.</span>
              <span className="uppercase">{title}</span>
            </h2>

            <p className="ml-[35px] mt-[10px] text-[16px] font-[400] leading-[20px]">{content}</p>
          </li>
        );
      })}
    </ul>
  );
};

export default WhatHappensNext;
